<template>
  <div>
    <v-container fluid class="content-wrapper">
      <v-card class="mt-3 pa-2 pa-sm-6 pa-lg-6 pa-xl-6 pa-md-6">
        <v-row>
          <v-col cols="12">
            <v-list dense>
              <v-list-item v-for="notification in notifications" :key="notification.id">
                <notification-item :notification="notification"> </notification-item>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card>
      <v-row v-if="notifications.length > 0" class="custom-pagination pt-5">
        <v-spacer></v-spacer>
        <v-col cols="4" md="2" class="justify-end d-flex flex-row align-center">
          <div>{{ notificationsLength }} Results</div>
        </v-col>
        <v-col cols="8" md="2" class="justify-end d-flex flex-row align-center">
          <div class="pr-2">Show:</div>
          <div style="max-width: 90px">
            <v-select
              v-model="itemsPerPage"
              :items="[5, 10, 15, 25, 50, 100]"
              dense
              outlined
              hide-details
            ></v-select>
          </div>
        </v-col>
        <v-col cols="12" md="4" class="justify-end d-flex flex-row align-center">
          <v-pagination
            v-model="options.page"
            :length="pagesLength"
            :total-visible="7"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import NotificationItem from '@/components/notifications/NotificationItem';

export default {
  name: 'Notifications',
  components: {
    NotificationItem,
  },
  data() {
    return {
      firstLoad: true,
      loading: false,
      tab: null,
      notifications: [],
      notificationsLength: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      total: null,
      pagesLength: 1,
      itemsPerPage: 10,
      search: {},
      searchAttributes: [],
    };
  },
  mounted() {
    /* Populate table from route */
    this.options.page = this.$route.query.index ? Number(this.$route.query.index) + 1 : 1;
    this.options.itemsPerPage = this.$route.query.size ? Number(this.$route.query.size) : 10;
    this.options.sortBy = [];
    this.options.sortDesc = [];
    if (this.$route.query.sort) {
      const sortList = this.$route.query.sort.split(',');
      for (let i = 0; i < sortList.length; i += 1) {
        this.options.sortBy.push(sortList[i].split(' ')[0]);
        if (sortList[i].split(' ')[1] === 'asc') {
          this.options.sortDesc.push(false);
        } else {
          this.options.sortDesc.push(true);
        }
      }
    }
    for (let i = 0; i < this.searchAttributes.length; i += 1) {
      const attr = this.searchAttributes[i];
      if (this.$route.query[attr]) {
        this.$set(this.search, attr, this.$route.query[attr]);
      }
    }
    this.itemsPerPage = this.options.itemsPerPage;
    this.sortBy = this.options.sortBy.length > 0 ? this.options.sortBy[0] : null;
    this.getDataFromApi();
    this.queries = this.$route.query.text ? this.$route.query.text : '';
  },
  methods: {
    getParams() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const query = {
        index: page - 1,
        size: itemsPerPage,
      };
      let sort = '';
      for (let i = 0; i < sortBy.length; i += 1) {
        if (i !== 0) {
          sort += ',';
        }
        let dir = 'asc';
        if (sortDesc[i]) {
          dir = 'desc';
        }
        sort += `${sortBy[i]} ${dir}`;
      }
      if (sort !== '') {
        query.sort = sort;
      }
      for (let i = 0; i < this.searchAttributes.length; i += 1) {
        const attr = this.searchAttributes[i];
        if (this.search[attr]) {
          query[attr] = this.search[attr];
        }
      }
      return query;
    },
    changeOptions() {
      console.log('change options');
      this.$router
        .push({
          path: this.$router.path,
          query: this.getParams(),
        })
        .catch(err => {
          throw new Error(`Problem handling something: ${err}.`);
        });
    },
    getDataFromApi() {
      this.axios
        .get('/api/v1/notifications', {
          params: this.getParams(),
        })
        .then(res => {
          this.notifications = res.data.content;
          this.pagesLength = res.data.pagesLength;
          this.notificationsLength = res.data.total;
          this.firstLoad = false;
        });
    },
  },
  watch: {
    options: {
      handler() {
        console.log('[Table] Options watch');
        if (!this.firstLoad) {
          this.changeOptions();
        }
      },
      deep: true,
    },
    itemsPerPage(value) {
      if (!this.firstLoad) {
        this.options = {
          ...this.options,
          itemsPerPage: value,
          page: 1,
        };
      }
    },
  },
};
</script>
